import register from '@kpsys/angularjs-register';
import {defaultContextFactory} from './svelte-context/default-context.factory';
import {clientSideBotDetection} from './config';
import {KpSvelteComponentWrapperComponent} from './kp-svelte-component-wrapper/kp-svelte-component-wrapper.component';
import {AjaxServiceProvider} from './data-services/ajax.service';
import ObservableAjaxServiceProvider from './data-services/observable-ajax.service';
import {ClientSessionVerifierDataService} from './data-services/client-session-verifier.data-service';
import {FileDownloadServiceProvider} from './data-services/file-download.service';
import {LogService} from './logging/log.service';
import {ChunkFileUploadService} from 'core/data-services/chunk-file-upload.service';

export default register('portaro.core')
    .run(clientSideBotDetection)
    .provider(AjaxServiceProvider.providerName, AjaxServiceProvider)
    .provider(FileDownloadServiceProvider.providerName, FileDownloadServiceProvider)
    .provider(ObservableAjaxServiceProvider.providerName, ObservableAjaxServiceProvider)
    .service(ClientSessionVerifierDataService.serviceName, ClientSessionVerifierDataService)
    .service(ChunkFileUploadService.serviceName, ChunkFileUploadService)
    .service(LogService.serviceName, LogService)
    .factory(defaultContextFactory.factoryName, defaultContextFactory)
    .component(KpSvelteComponentWrapperComponent.componentName, KpSvelteComponentWrapperComponent)
    .name();
